<template>
  <div>
    <dialog-edit :value="value" @input="$emit('input')" :maxWidth="'100hv'">
      <template v-slot:title>
        Выбор позиций, ожидающих приёмки {{ getAccess("documents.goodsIncome.fullIncomeList") ? "[Полный доступ]" : "[Не полный доступ]" }}
      </template>
      <v-card-text style="height: 80vh; overflow: auto" class="pa-0">
        <a-table-f-api-post
          ref="table"
          :apiPost="{ api: '/report_sql/filters', params: paramsApi }"
          :limit1="50"
          :model="model"
          :useQuery="false" 
          :defaults="{
            paramName: 'goods.goodsIncome',
            pager: { limit: 50, page: 0 },
            sort: [
              { key: 'is_date', order: 'ASC' },
              { key: 'date_before', order: 'ASC' },
              { key: 'date_doc', order: 'ASC' },
              { key: 'id', order: 'ASC' },
            ],
          }"
          @click="clickRow"
        />
      </v-card-text>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save v-if="getAccess('documents.goodsIncome.create')" @click="add()" :title="'Принять выбранное'" />
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit>
  </div>
</template>

<script>
import { getAccess } from "@/components/mixings";

export default {
  components: {},
  mixins: [getAccess],
  props: {
    value: Boolean,
    storage: Object,
    order_id: Number,
    type: { type: String, default: "AddFromIncome" },
  },
  data() {
    return {
      url: "/accounting/doc/goods_income",
      dataTable: [],
      sql: {},
      filterSql: "",
      filterData: { objects: [], storages: [] },
    };
  },
  computed: {
    paramsApi() {
      return {
        name: "goodsIncome_getGoodsList",
        params: {
          object_id: this?.storage?.object_id || -1,
          order_id: this.order_id || -1,
          user_id: this.getAccess("documents.goodsIncome.fullIncomeList") ? -1 : this.$root.profile.id,
        },
      };
    },
    filter: {
      get() {
        let res = this.$store.getters["config/getLocalParams"]?.["goodsIncomeList.filter"] || -1;
        return res;
      },
      set(v) {
        this.$store.commit("config/setLocalParams", {
          name: "goodsIncomeList.filter",
          value: v,
        });
      },
    },
    model() {
      let model = JSON.parse(JSON.stringify(this.$store.getters["config/get"].models.documentOrderGoods.listDetail));
      model.find(m => {
        return m.name == "name";
      }).style = "white-space: normal;";
      model = [
        { name: "checked", type: "checkbox", width: 35, hidden: !this.getAccess("documents.goodsIncome.create") },
        { name: "name_doc", title: "Заказ товаров", type: "string", width: 135, style: "white-space: normal;" },
        {
          name: "object_name",
          title: "Для объекта...",
          type: "string",
          style: "white-space: normal;",
          filter: {
            name: "object_code",
            type: "selectapi",
            api: {
              type: "post",
              api: "/report_sql",
              data: {
                name: "goodsIncome_getTargetList",
                params: {
                  object_id: this?.storage?.object_id || -1,
                  order_id: this.order_id || -1,
                  user_id: this.getAccess("documents.goodsIncome.fullIncomeList") ? -1 : this.$root.profile.id,
                  type: 1,
                },
              },
            },
            sql: this.filterSql.objects,
          },
          sortable: true,
          width: 150,
        },
        {
          name: "store_name",
          title: "Для склада...",
          type: "string",
          style: "white-space: normal;",
          filter: {
            name: "store_id",
            type: "selectapi",
            api: {
              type: "post",
              api: "/report_sql",
              data: {
                name: "goodsIncome_getTargetList",
                params: {
                  object_id: this?.storage?.object_id || -1,
                  order_id: this.order_id || -1,
                  user_id: this.getAccess("documents.goodsIncome.fullIncomeList") ? -1 : this.$root.profile.id,
                  type: 3,
                },
              },
            },
            sql: this.filterSql.storages,
          },
          sortable: true,
          width: 150,
        },
        { name: "date_before", title: "Дата ожид.", type: "date", width: 80 },
        ...model.filter(el => {
          return ["id", "name", "amount", "measure", "price_real"].includes(el.name);
        }),
        {
          name: "doc_goods_income_id",
          title: "Приемка в",
          type: "selectapi",
          itemField: { value: "id", text: "code_doc" },
          api: "accounting/doc/goods_income",
          preText: "Приемка №",
          style: "white-space: normal;",
          sortable: true,
          width: 150,
          style: "text-align:left;",
        },
      ];
      return model;
    },
  },
  created() {
    this.getData();
  },
  watch: {
    value() {
      if (this.value) {
      }
    },
  },
  methods: {
    onInputFilter(f) {
      console.log("filter", f);
    },
    clickRow(d) {
      this.$refs.table.$refs.base.clickCheckbox(d.event, d.row);
      this.$refs.table.$refs.base.$forceUpdate();
    },
    add() {
      let rows = [];
      let order = null;

      for (let row of this.$refs.table.data.filter(el => {
        return el?.checked;
      })) {
        if (!order) order = row.order_goods_id;
        if (order !== row.order_goods_id) {
          this.$root.$emit("show-info", {
            type: "error",
            text: `Принимаемые товары должны быть из одного заказа товаров `,
          });
          return;
        }
        let comments = null;
        if (row.store_name) comments = `для склада ${row.store_name}`;
        if (row.object_name) comments = `для объекта ${row.object_name}`;
        rows.push({
          accounting_doc_order_goods_table_id: row.id,
          name: row.name,
          amount: row.amount,
          measure: row.measure,
          value: row.price_real,
          order_goods_id: row.order_goods_id,
          comments,
          object_id: parseInt(row.object_code),
          store_id: row.store_id,
        });
      }
      if (rows.length == 0) return;
      this.$emit("save", rows);
      this.$emit("input");
    },
  },
};
</script>
